import { useState } from "react";
import { Article, SearchMode } from "@/features/search/types/search";
import { getEmbedding, fetchArticlesByEmbedding } from "@/api/utils";
export const useArticleSearch = () => {
  const [searchResults, setSearchResults] = useState<Article[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const [query, setQuery] = useState("");
  const [searchError, setSearchError] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setQuery(e.target.value);
  };

  const clearSearchResults = () => {
    setSearchResults([]);
  };

  const handleSearch = async (
    query: string,
    searchMode: SearchMode,
    daysAgo: number,
    MATCH_COUNT?: number
  ) => {
    setIsSearching(true);
    setSearchError(null);

    try {
      const embedding = await getEmbedding(query);
      if (!embedding) {
        throw new Error("Failed to generate embedding");
      }
      console.log("embedding", embedding);
      const articles = await fetchArticlesByEmbedding({
        embedding,
        daysAgo,
        searchMode,
        matchCount: MATCH_COUNT,
      });
      setSearchResults(articles as Article[]);
    } catch (error) {
      console.error("Search failed at handleSearch:", error);
      setSearchError("Search failed. Please try again later.");
    } finally {
      setIsSearching(false);
    }
  };

  const handleSubmit = (
    e: React.FormEvent<HTMLFormElement>,
    activeMode: SearchMode,
    daysAgo: number,
    MATCH_COUNT: number
  ) => {
    e.preventDefault();
    handleSearch(query, activeMode, daysAgo, MATCH_COUNT);
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    activeMode: SearchMode,
    daysAgo: number,
    MATCH_COUNT: number
  ) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();

      handleSearch(query, activeMode, daysAgo, MATCH_COUNT);
    }
  };

  return {
    searchResults,
    isSearching,
    searchError,
    query,
    handleSearch,
    handleChange,
    handleSubmit,
    handleKeyDown,
    clearSearchResults,
  };
};
